import { chakra } from '@chakra-ui/react'

export const DownloadPanel = chakra('div', {
    baseStyle: ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
        padding: '8px 0',
        borderRadius: '3px',
        backgroundColor: theme.palette.downloadControl.backgroundColor,

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            padding: '8px 16px',
        },
    }),
})

/* `DownloadPanel` is `align-items: flex-start` and its `gap` now spaces this list, not the rows —
 * so dropping `width` or `gap` here visibly narrows and un-spaces every option. */
export const DownloadOptionList = chakra('ul', {
    baseStyle: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
})

export const DownloadOptionItem = chakra('li', {})

export const DownloadOption = chakra('button', {
    baseStyle: ({ theme }) => ({
        width: '100%',
        padding: '8px 16px',
        fontSize: '14px',
        lineHeight: '21px',
        textAlign: 'left',
        color: theme.palette.downloadControl.textColor,

        _hover: {
            backgroundColor: theme.palette.downloadControl.optionHoverColor,
        },

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            fontSize: '18px',
            lineHeight: '28px',
        },
    }),
})
